/* Velvet Bunny — OFFERS add-on JS (preview theme). Vanilla, guarded. */
(function () {
  'use strict';
  if (window.__mtOffersInit) return;
  window.__mtOffersInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function initOffers() {
    var root = document.querySelector('[data-mt-offers]');
    if (!root) return;

    var form = root.querySelector('form.mt-pdp__buyform') || document.querySelector('form.mt-pdp__buyform');
    var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
    var addBtn = document.querySelector('[data-mt-add]');
    var addLabel = addBtn ? (addBtn.getAttribute('data-label-add') || 'Add to cart') : 'Add to cart';

    var bundles = Array.from(root.querySelectorAll('[data-mt-bundle]'));
    var threshold = parseInt(root.getAttribute('data-ship-threshold'), 10) || 3500;

    // Ship bar
    var shipWrap = document.querySelector('[data-mt-ship]');
    var shipText = document.querySelector('[data-mt-ship-text]');
    var shipFill = document.querySelector('[data-mt-ship-fill]');

    // Sticky
    var stickyPrice = document.querySelector('[data-mt-sticky-price]');
    var stickyWas = document.querySelector('[data-mt-sticky-was]');

    function updateShip(totalCents) {
      if (!shipWrap) return;
      var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
      if (shipFill) shipFill.style.width = pct + '%';
      if (totalCents >= threshold) {
        shipWrap.classList.add('is-complete');
        if (shipText) shipText.innerHTML = '<b>You’ve unlocked free shipping!</b> 🎉';
      } else {
        shipWrap.classList.remove('is-complete');
        var left = threshold - totalCents;
        if (shipText) shipText.innerHTML = 'Add <b>' + money(left) + '</b> more for <b>free shipping</b>';
      }
    }

    var activeCard = null;
    function select(card) {
      activeCard = card;
      bundles.forEach(function (b) { b.classList.remove('is-active'); var i = b.querySelector('input'); if (i) i.checked = false; });
      card.classList.add('is-active');
      var inp = card.querySelector('input'); if (inp) inp.checked = true;
      var qty = parseInt(card.getAttribute('data-qty'), 10) || 1;
      var total = parseInt(card.getAttribute('data-total'), 10) || 0;
      if (qtyInput) qtyInput.value = qty;
      if (addBtn && !addBtn.disabled) addBtn.textContent = addLabel + ' • ' + money(total);
      if (stickyPrice) stickyPrice.textContent = money(total);
      if (stickyWas) {
        var was = parseInt(card.getAttribute('data-was'), 10) || 0;
        if (was > total) { stickyWas.textContent = money(was); stickyWas.style.display = ''; }
        else { stickyWas.style.display = 'none'; }
      }
      updateShip(total);
    }

    bundles.forEach(function (card) {
      card.addEventListener('click', function () { select(card); });
    });

    // default selection: the one marked highlight, else first
    var def = bundles.find(function (b) { return b.getAttribute('data-default') === 'true'; }) || bundles[0];
    if (def) select(def);

    // Re-assert the bundle label after the variant script runs (on load and on color change)
    function reapply() { if (activeCard) select(activeCard); }
    setTimeout(reapply, 60);
    document.querySelectorAll('[data-mt-option]').forEach(function (inp) {
      inp.addEventListener('change', function () { setTimeout(reapply, 0); });
    });

    // --- Multi-variant bundles: add each chosen handset (plug + color) to cart ---
    var variants = [];
    try { variants = JSON.parse(document.querySelector('[data-mt-variants]').textContent); } catch (e) { variants = []; }
    function findVariant(sel) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return sel[v.optionNames[i]] === opt; });
      });
    }
    // When a bundle card is clicked, make sure its per-item rows show (and selecting inside a row keeps that bundle active)
    var mainImg = document.querySelector('[data-mt-main-img]');
    function syncImageFromRow(wrap) {
      if (!mainImg || !wrap) return;
      var firstRow = wrap.querySelector('.mt-bundle__row');
      if (!firstRow) return;
      var sel = {};
      firstRow.querySelectorAll('.mt-bundle__select').forEach(function (s) { sel[s.getAttribute('data-opt')] = s.value; });
      var v = findVariant(sel);
      if (v && v.image) {
        mainImg.src = v.image;
        var hid = form ? form.querySelector('[data-mt-variant-id]') : null;
        if (hid) hid.value = v.id;
        document.querySelectorAll('[data-mt-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-full') === v.image);
        });
      }
    }
    document.querySelectorAll('[data-bundle-items]').forEach(function (wrap) {
      wrap.addEventListener('change', function () {
        var card = wrap.previousElementSibling;
        if (card && card.hasAttribute('data-mt-bundle')) select(card);
        syncImageFromRow(wrap);
      });
    });

    function mtUpsellItems() {
      var u = [];
      document.querySelectorAll('[data-mt-upsell]').forEach(function (cb) {
        var id = cb.getAttribute('data-variant-id');
        if (cb.checked && id) { u.push({ id: parseInt(id, 10), quantity: 1 }); }
      });
      return u;
    }
    function mtMainVariantId() {
      var h = form ? form.querySelector('[data-mt-variant-id]') : null;
      if (h && h.value) { return parseInt(h.value, 10); }
      return variants[0] ? variants[0].id : null;
    }
    function mtAjaxAdd(items) {
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { if (addBtn) { addBtn.disabled = false; } if (form) form.submit(); });
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        var ups = mtUpsellItems();
        var qty = activeCard ? (parseInt(activeCard.getAttribute('data-qty'), 10) || 1) : 1;
        // One line per chosen color (works for 1 kit or several)
        if (activeCard && qty >= 1) {
          var wrap = activeCard.nextElementSibling;
          if (wrap && wrap.classList.contains('mt-bundle__items')) {
            var rows = wrap.querySelectorAll('.mt-bundle__row');
            if (rows.length) {
              var items = [];
              var ok = true;
              rows.forEach(function (row) {
                var sel = {};
                row.querySelectorAll('.mt-bundle__select').forEach(function (s) { sel[s.getAttribute('data-opt')] = s.value; });
                var v = findVariant(sel);
                if (v && v.available) { items.push({ id: v.id, quantity: 1 }); }
                else { ok = false; }
              });
              if (items.length) {
                e.preventDefault();
                if (!ok) { alert('One of the chosen combinations is out of stock — please pick another.'); return; }
                mtAjaxAdd(items.concat(ups));
                return;
              }
            }
          }
        }
        // Single item (or bundle without rows) + any upsells
        if (ups.length) {
          var mid = mtMainVariantId();
          if (mid) {
            e.preventDefault();
            mtAjaxAdd([{ id: mid, quantity: qty }].concat(ups));
            return;
          }
        }
        // otherwise: native single-item submit
      });
    }

    initCountdown();
    initSticky(addBtn);
  }

  function initCountdown() {
    var el = document.querySelector('[data-mt-countdown]');
    if (!el) return;
    var DAY = 86400000, KEY = 'mt_cd_deadline';
    // Rolling 24-hour countdown, shared with the top bar, resets every 24h
    function getDL() {
      var now = Date.now(), dl = 0;
      try { dl = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) {}
      if (!dl || dl <= now || dl - now > DAY) { dl = now + DAY; try { localStorage.setItem(KEY, String(dl)); } catch (e) {} }
      return dl;
    }
    var deadline = getDL();
    var cells = {
      d: el.querySelector('[data-cd="d"]'), h: el.querySelector('[data-cd="h"]'),
      m: el.querySelector('[data-cd="m"]'), s: el.querySelector('[data-cd="s"]')
    };
    // 24h timer: hide the DAYS cell
    if (cells.d) { var dc = cells.d.closest('.mt-countdown__cell'); if (dc) dc.style.display = 'none'; }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) { deadline = getDL(); diff = deadline - Date.now(); }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (cells.h) cells.h.textContent = pad(h);
      if (cells.m) cells.m.textContent = pad(m);
      if (cells.s) cells.s.textContent = pad(s);
    }
    tick();
    var timer = setInterval(tick, 1000);
  }

  function initSticky(addBtn) {
    var sticky = document.querySelector('.mt-sticky-atc');
    if (!sticky || !addBtn) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // show sticky when the main add button is NOT visible
        sticky.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(addBtn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOffers);
  } else {
    initOffers();
  }
})();
